export default __webpack_public_path__ + "static/media/E6.bfba4cc6.mp3";